module.exports = __webpack_public_path__ + "img/confetti_dialog.5cc53fa3.png";